'use client';

import React from 'react';
import Link from 'next/link';
import { urlFor } from '@/sanity/lib/image';
import GfSectionMark from '@/components/common/GfSectionMark';
import { t } from '@/i18n/translations';

// Thematic blog collections — internal links, restyled to "Gallery · Field".
export default function ThematicCollections({ collections = [], lang = 'ru' }) {
    if (!collections || collections.length === 0) return null;
    const isRu = lang === 'ru';
    const ui = t(lang, 'accommodationUi');

    const sorted = [...collections].sort((a, b) => (a.order || 0) - (b.order || 0));

    return (
        <section className="gf-sec" id="thematic" style={{ paddingTop: 0 }}>
            <GfSectionMark eyebrow={ui.thematic.eyebrow} title={ui.thematic.title} />
            <p className="gf-lead">{ui.thematic.lead}</p>
            <div className="gf-arts">
                {sorted.map((collection, index) => {
                    const title = isRu ? collection.titleRu : collection.titleEn;
                    const subtitle = isRu ? collection.subtitleRu : collection.subtitleEn;
                    const imgSrc = collection.image;
                    const img = imgSrc?.asset ? urlFor(imgSrc).width(760).height(480).url() : null;
                    const linkUrl = collection.articles && collection.articles.length > 0
                        ? `/${lang}/blog/${collection.articles[0].slug?.current || collection.articles[0].slug}`
                        : `/${lang}/blog`;
                    return (
                        <Link className="ar" href={linkUrl} key={collection._id || index}>
                            <div className="ph">
                                {img && <img src={img} alt={imgSrc?.alt || title} loading="lazy" />}
                            </div>
                            <div className="ar-body">
                                <h3>{title}</h3>
                                {subtitle && <p className="ex">{subtitle}</p>}
                                <span className="read">{ui.thematic.open}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
}
